import { Link } from 'react-router-dom';
import logoWhite from '../static/logo-white.png';
import { useState } from 'react';
import { Branch } from '../utils/enum';
const signalIcon = './static/icons/signal.svg';
const instagramIcon = './static/icons/instagram.svg';
const whatsappIcon = './static/icons/whatsapp.svg';
const instagramUrl = 'https://www.instagram.com/syt.cmp/';

interface BranchContact {
  branch: Branch;
  label: string;
  address?: string[];
  mapUrl?: string;
  phone: string;
  phoneUrl?: string;
  whatsappUrl?: string;
  signalUrl?: string;
  instagramUrl?: string;
}

const BRANCH_CONTACTS: Record<Branch, BranchContact> = {
  [Branch.KWAI_FONG]: {
    branch: Branch.KWAI_FONG,
    label: '葵芳',
    address: ['新界葵芳興芳路223號新都會廣場一期21樓', '2113-2114室'],
    mapUrl:
      'https://www.google.com/maps?q=%E8%91%B5%E6%B6%8C%E8%88%88%E8%8A%B3%E8%B7%AF223%E8%99%9F%E6%96%B0%E9%83%BD%E6%9C%83%E5%BB%A3%E5%A0%B4%E7%AC%AC%E4%B8%80%E5%BA%A7%E5%BF%A0%E9%86%AB%E8%A8%BA%E6%89%80+%E8%81%96%E8%B3%A2%E5%A0%8221%E6%A8%932113-2114%E5%AE%A4',
    phone: '23332025, 64491632 (10:00-19:00)',
    phoneUrl: 'tel:+85223332025',
    whatsappUrl: 'https://wa.me/85296671254',
    // whatsappUrl: 'https://wa.me/85264491632',
    signalUrl: 'https://signal.me/#p/+85264491632',
    instagramUrl,
  },
  [Branch.YUEN_LONG]: {
    branch: Branch.YUEN_LONG,
    label: '元朗',
    address: ['元朗青山公路-元朗段2號保安樓', '地下E及G舖'],
    mapUrl: 'https://g.co/kgs/jnVDmRd',
    phone: '24683668, 63811939 (10:00-19:00)',
    phoneUrl: 'tel:+85224683668',
    whatsappUrl: 'https://wa.me/85296671254',
    // whatsappUrl: 'https://wa.me/85263811939',
    signalUrl: 'https://signal.me/#p/+85263811939',
    instagramUrl,
  },
  [Branch.KWUN_TONG]: {
    branch: Branch.KWUN_TONG,
    label: '觀塘',
    address: ['觀塘觀塘道418號創紀之城5期-東亞銀行中心', '16樓08室(APM樓上)'],
    mapUrl: 'https://g.co/kgs/q2SDS9X',
    phone: '23236992, 61540243 (10:00-19:00)',
    phoneUrl: 'tel:+85223236992',
    whatsappUrl: 'https://wa.me/85296671254',
    // whatsappUrl: "https://wa.me/85261540243",
    signalUrl: 'https://signal.me/#p/+85261540243',
    instagramUrl,
  },
  [Branch.SHEK_MUN]: {
    branch: Branch.SHEK_MUN,
    label: '石門',
    address: ['沙田石門安耀街5號', 'W LUXE大廈23樓N1'],
    mapUrl:
      'https://www.google.com/maps/search/?api=1&query=%E6%B2%99%E7%94%B0%E7%9F%B3%E9%96%80%E5%AE%89%E8%80%80%E8%A1%975%E8%99%9F%20W%20LUXE%E5%A4%A7%E5%BB%8823%E6%A8%93N1',
    phone: '2412 3466 (10:00-19:00)',
    phoneUrl: 'tel:+85224123466',
    whatsappUrl: 'https://wa.me/85296671254',
    instagramUrl,
  },
  [Branch.UK_VIDEO]: {
    branch: Branch.UK_VIDEO,
    label: '視像診症',
    address: ['英國視像診症'],
    phone: '+44 7762 175520 (15:00-18:30 HKT)',
    phoneUrl: 'tel:+447762175520',
    whatsappUrl: 'https://wa.me/447762175520',
  },
};

const SocialButton = ({
  url,
  icon,
  label,
}: {
  url: string;
  icon: string;
  label: string;
}) => (
  <button
    onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
    aria-label={label}
  >
    <img src={icon} alt={label} width={34} height={34} />
  </button>
);

const Footer = () => {
  const [activeTab, setActiveTab] = useState(Branch.KWAI_FONG);
  const activeClinic = BRANCH_CONTACTS[activeTab];

  return (
    <footer className="flex flex-col justify-between bg-[#ACA394] pb-6 pt-10 text-white xl:min-h-[400px] xl:pt-8">
      <nav className="discovery-links" aria-label="分店及診症資料"><Link to="/clinics">分店地址</Link><Link to="/doctors">醫師詳細介紹</Link><Link to="/services">診症方向</Link></nav>
      <div className="mx-auto flex w-full max-w-[1600px] flex-col justify-between gap-10 px-10 md:px-20 xl:flex-row xl:gap-64">
        <div className="flex flex-1 justify-center">
          {' '}
          <img
            src={logoWhite}
            className="h-auto w-[100px] xl:h-48 xl:w-auto"
            alt="聖賢堂標誌"
          ></img>
        </div>
        <div className="flex-1 shrink-0 flex-col items-center justify-center text-sm xl:text-base">
          <p className="text-center">應診服務時間</p>
          <p className="mt-4 text-center">各分店及醫師應診時間不同</p>
          <p className="mt-4 text-center"><Link to="/clinics">查看分店及醫師排班</Link></p>
          <p className="mt-4 text-center">公眾假期: 將另行通知</p>
        </div>
        <div className="flex-1 flex-col justify-center text-sm xl:text-base">
          <p className="text-center" style={{ borderBottom: 'dashed' }}>
            聯絡資料
          </p>

          <div className="flex-1 flex-col justify-center text-sm xl:text-base">
            <div className="mb-4 flex flex-wrap justify-center gap-4">
              {Object.values(BRANCH_CONTACTS).map(({ branch, label }) => (
                <button
                  key={branch}
                  className={`pb-1 ${activeTab === branch ? 'border-b-2' : ''}`}
                  onClick={() => setActiveTab(branch)}
                >
                  {label}
                </button>
              ))}
            </div>
            <div>
              {activeClinic.address && (
                <div className="flex justify-center gap-4 text-center">
                  {activeClinic.mapUrl ? (
                    <a
                      href={activeClinic.mapUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {activeClinic.address.map((line) => (
                        <p key={line}>{line}</p>
                      ))}
                    </a>
                  ) : (
                    <div>
                      {activeClinic.address.map((line) => (
                        <p key={line}>{line}</p>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div className="mt-6 flex w-full justify-center gap-4">
                {activeClinic.phoneUrl ? (
                  <a href={activeClinic.phoneUrl}>{activeClinic.phone}</a>
                ) : (
                  <p>{activeClinic.phone}</p>
                )}
              </div>
              <div className="mt-2 flex justify-center gap-4">
                {activeClinic.whatsappUrl && (
                  <SocialButton
                    url={activeClinic.whatsappUrl}
                    icon={whatsappIcon}
                    label="WhatsApp"
                  />
                )}
                {activeClinic.signalUrl && (
                  <SocialButton
                    url={activeClinic.signalUrl}
                    icon={signalIcon}
                    label="Signal"
                  />
                )}
                {activeClinic.instagramUrl && (
                  <SocialButton
                    url={activeClinic.instagramUrl}
                    icon={instagramIcon}
                    label="Instagram"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto mt-20 flex w-full max-w-[1600px] justify-center pb-5 md:justify-end md:px-20 md:pb-0 xl:mt-0">
        <div className="right-0 flex flex-col gap-8 text-xs md:flex-row md:text-sm">
          <Link to="/info" className="cursor-pointer hover:underline">
            關於我們
          </Link>
          <Link to="/intro" className="cursor-pointer hover:underline">
            醫師介紹
          </Link>
          <Link to="/diary" className="cursor-pointer hover:underline">
            聖賢隨記
          </Link>
          <Link to="/pricing" className="cursor-pointer hover:underline">
            服務及收費
          </Link>
          <Link to="/blogs" className="cursor-pointer hover:underline">
            聖賢中醫錦囊
          </Link>
          <Link to="/charity" className="cursor-pointer hover:underline">
            慈善公益
          </Link>
          <Link to="/privacy" className="cursor-pointer hover:underline">
            私隱政策
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

